import React from 'react';
import styled from 'styled-components';
import {MdErrorOutline} from 'react-icons/md';
import {MdClose} from 'react-icons/md';


const ToastWrapper = styled.div`
  width: 300px;
  border-radius: 8px;
  box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.5);
  padding: 15px 10px;
  background: #282F35;
  position: fixed;
  z-index: 7000;
  top: 20px;
  right: 20px;
  color: #fff;
  font-size: 12px;
`;

const ToastTitle = styled.div`
  color: red;
  font-size: 16px;
  margin-bottom: 5px;
`;

const Close = styled(MdClose)`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;

const ErrorToast = ({children,close}) => (
  <ToastWrapper>
    <Close onClick={close} />
    <ToastTitle>
      <MdErrorOutline />
      <span> Error:</span>
    </ToastTitle>
    <div>{children}</div>
  </ToastWrapper>
);

export default ErrorToast;
